<span [class.circle]="theme()"
      [class.framed]="framed()"
      [class.loaded]="isMaterialSymbolsFontLoaded()"
      [class.tooltip]="tooltipDescription() !== ''"
      [style]="{
          fontSize: fontSize() + 'px',
          fontVariationSettings: '\'FILL\'' + (filled() ? 1 : 0) + ',' + '\'wght\'' + boldness(),
          padding: (framed() || theme() !== undefined) ? paddingSize() + 'px' : 0,
          maxWidth: maxWidth() + 'px'
      }"
      [workUiTooltip]="tooltipDescription()"
      (click)="iconClicked($event)"
      class="work-ui-icon material-symbols-rounded work-ui-icon--theme-{{theme()}} work-ui-icon--fontcolor-{{fontColor()}}"
      translate="no">
  {{ name() }}
</span>
